module.exports = __webpack_public_path__ + "img/Frame 6796@2x.1f870054.png";